<template>
  <div v-if="$store.state.showAnnotations" id="annotations" :class="[$store.state.drawingAnnotation ? 'showOverlay' : '']" :style="$store.state.drawingAnnotation ? '' : 'pointer-events:none;'">
    <annotation-controls></annotation-controls>
    <div v-show="drawMode" id="currentAnnotation" :style="currentAnnotationStyle" draggable="false">
      <textarea v-if="this.currentAnnotation.type === 'text'"></textarea>
      <div v-else-if="this.currentAnnotation.type === 'highlight'">

      </div>
      <img v-else draggable="false" :src="'/static/' + this.currentAnnotation.type + '.svg'">
    </div>

    <div class="annotationDisplay" :id="'annotationDisplay-' + index" v-for="(annotation, index) in $store.state.annotations" :key="index"
      :style="'left:' + annotation.x + 'px;top:' + annotation.y + 'px;width:' + annotation.width + 'px;height:' + annotation.height + 'px;'" :rotation="annotation.rotation">
        <annotation-textarea :id="'annotation-' + index" v-if="annotation.type === 'text'"
          :index="index" :width="annotation.width" :height="annotation.height" :rotation="annotation.rotation" :storeData="annotation.data"></annotation-textarea>
        <annotation-highlight :id="'annotation-' + index" v-else-if="annotation.type === 'highlight'"
          :index="index" :width="annotation.width" :height="annotation.height" :rotation="annotation.rotation"></annotation-highlight>
        <annotation-image :id="'annotation-' + index" v-else :selected="annotation.selected"
          :name="annotation.type" :index="index" :width="annotation.width"
          :height="annotation.height" :rotation="annotation.rotation"></annotation-image>
    </div>
  </div>
</template>

<script>
import AnnotationControls from '@/components/editor/annotations/AnnotationControls'
import AnnotationTextarea from '@/components/editor/annotations/AnnotationTextarea'
import AnnotationImage from '@/components/editor/annotations/AnnotationImage'
import AnnotationHighlight from '@/components/editor/annotations/AnnotationHighlight'

export default {
  name: 'annotations',

  components: {
    AnnotationControls,
    AnnotationTextarea,
    AnnotationImage,
    AnnotationHighlight
  },

  mounted () {
    let that = this
    this.$bus.$on('setAnnotationMode', function (type) {
      that.currentAnnotation.type = type
    })

    this.$bus.$on('removeAnnotation', function (index) {
      that.$store.commit('removeAnnotation', index)
      that.$bus.emit('hideControls')
    })

    this.$bus.$on('pageChange', function () {
      that.setup()
    })

    this.$bus.$on('setSelected', function (index) {
      console.log('Set Selected', index)
      for (let i = 0; i < that.$store.state.annotations.length; i++) {
        if (i === index) that.$store.commit('setSelected', {index: i, val: false})
        else that.$store.commit('setSelected', {index: i, val: true})
      }
    })

    this.$bus.on('moveAnnotation', this.setMoveMode)
    this.$bus.on('resizeAnnotation', this.setResizeMode)
    this.$bus.on('rotateAnnotation', this.setRotateMode)

    document.addEventListener('mousedown', this.mouseDown, false)
    document.addEventListener('mouseup', this.mouseUp, false)
    document.addEventListener('mousemove', this.mouseMove, false)
    document.addEventListener('keyup', this.keyPress, false)
  },

  data () {
    return {
      annotations: [],
      currentAnnotation: {
        x: 0,
        y: 0,
        rotation: 0,
        width: 10,
        height: 10,
        type: 'text',
        selected: false,
        data: {}
      },

      drawMode: false,
      rotateMode: false,
      moveMode: false,
      resizeMode: false,
      targetIndex: -1
    }
  },

  methods: {
    setup () {
      let annotations = this.$store.getters.pageAnnotations(this.$store.state.fileCurrentPage)
      this.$store.commit('setAnnotations', annotations)
    },

    updateControlsPosition () {
      const type = this.$store.state.annotations[this.targetIndex]['type']
      const annotationEl = document.querySelector('#annotation-' + this.targetIndex + ' .annotationEl')
      const elPos = annotationEl.getBoundingClientRect()
      this.$bus.emit('showAnnotationControls', {
        index: this.targetIndex,
        type: type,
        x: elPos.left,
        y: elPos.top + elPos.height
      })
    },

    setResizeMode (index) {
      this.$bus.emit('hideControls')
      this.targetIndex = index
      this.resizeMode = true
      console.log('resize', index)
    },

    setMoveMode (index) {
      this.$bus.emit('hideControls')
      this.targetIndex = index
      this.moveMode = true
    },

    setRotateMode (index) {
      this.$bus.emit('hideControls')
      this.targetIndex = index
      this.rotateMode = true
      console.log('rotate', index)
    },

    mouseDown (e) {
      if (this.$store.state.drawingAnnotation) this.drawStart(e)
    },

    mouseUp (e) {
      if (this.drawMode) this.drawEnd(e)
      else if (this.rotateMode) this.rotateEnd(e)
      else if (this.moveMode) this.moveEnd(e)
      else if (this.resizeMode) this.resizeEnd(e)
    },

    mouseMove (e) {
      if (this.drawMode) this.drawMove(e)
      else if (this.rotateMode) this.rotateMove(e)
      else if (this.moveMode) this.moveMove(e)
      else if (this.resizeMode) this.resizeMove(e)
    },

    keyPress (e) {

    },

    moveMove (e) {
      const pos = {
        x: e.pageX - 10,
        y: e.pageY - 10
      }
      this.$store.commit('setAnnotationPosition', {index: this.targetIndex, pos: pos})
    },

    moveEnd (e) {
      this.moveMove(e)
      this.moveMode = false
      this.updateControlsPosition()
      // this.$store.dispatch('saveAll')
    },

    rotateMove (e) {
      const mousePos = {x: e.pageX, y: e.pageY}
      const elRect = document.querySelector('#annotation-' + this.targetIndex).getBoundingClientRect()

      const mouseTravel = elRect.left - mousePos.x
      const rotationAmount = mouseTravel / 5
      this.$store.commit('setAnnotationRotation', {index: this.targetIndex, amount: rotationAmount})
    },

    rotateEnd (e) {
      this.rotateMove(e)
      this.rotateMode = false
      // this.$store.dispatch('saveAll')
    },

    resizeMove (e) {
      const mousePos = {x: e.pageX, y: e.pageY}
      const elRect = document.querySelector('#annotation-' + this.targetIndex).getBoundingClientRect()
      const elPos = {
        x: elRect.left,
        y: elRect.top
      }

      const size = {
        width: elRect.width,
        height: elRect.height
      }

      if (mousePos.x > elPos.x) size.width = (mousePos.x - elPos.x)
      if (mousePos.y > elPos.y) size.height = (mousePos.y - elPos.y)
      this.$store.commit('setAnnotationSize', {index: this.targetIndex, size: size})
    },

    resizeEnd (e) {
      this.resizeMove(e)
      this.resizeMode = false
      // this.$store.dispatch('saveAll')
    },

    drawStart (e) {
      if (this.drawMode) return
      this.currentAnnotation.width = 0
      this.currentAnnotation.height = 0
      this.currentAnnotation.x = e.pageX
      this.currentAnnotation.y = e.pageY
      this.drawMode = true
    },

    drawMove (e) {
      if (!this.$store.state.drawingAnnotation) return
      if (!this.drawMode) return

      if (e.pageX > this.currentAnnotation.x && e.pageY > this.currentAnnotation.y) {
        this.currentAnnotation.width = e.pageX - this.currentAnnotation.x
        this.currentAnnotation.height = e.pageY - this.currentAnnotation.y
      }
    },

    drawEnd (e) {
      if (!this.$store.state.drawingAnnotation) return
      if (!this.drawMode) return
      if (this.currentAnnotation.width > 10 && this.currentAnnotation.height > 10) {
        this.$store.commit('addAnnotation', {
          x: this.currentAnnotation.x,
          y: this.currentAnnotation.y,
          width: this.currentAnnotation.width,
          height: this.currentAnnotation.height,
          type: this.currentAnnotation.type,
          selected: true,
          fontSize: typeof this.currentAnnotation.fontSize !== 'undefined' ? this.currentAnnotation.fontSize : -1,
          rotation: 0,
          data: {}
        })
        // this.$store.dispatch('saveAll')
      }
      this.drawMode = false
    }
  },

  computed: {
    currentAnnotationStyle: function () {
      return 'top:' + this.currentAnnotation.y + 'px;left:' + this.currentAnnotation.x + 'px;width:' +
        this.currentAnnotation.width + 'px;height:' + this.currentAnnotation.height + 'px;'
    }
  },

  beforeDestroy () {
    this.$bus.$off('setAnnotationMode')
    this.$bus.$off('removeAnnotation')
    this.$bus.$off('pageChange')
    this.$bus.$off('setSelected')
    this.$bus.$off('moveAnnotation')
    this.$bus.$off('resizeAnnotation')
    this.$bus.$off('rotateAnnotation')
  }
}
</script>

<style lang="scss" scoped>
  #annotations {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 110%;
    z-index:10;

    .annotationDisplay {
      position: absolute;
      user-select: none;
      pointer-events: initial;
      z-index: 10;
    }

    #currentAnnotation {
      position: absolute;
      top: 0;
      left: 0;
      width: 50px;
      height: 50px;
      border: 1px dashed black;
      z-index: 10;

      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
        user-select: none;
      }

      textarea {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
        user-select: none;
        resize: none;
      }
    }
  }

  .showOverlay {
    background-color: rgba(0,0,0,0.6);
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/main/Annotations.vue